import axios from "axios";
import toast from "react-hot-toast";

const ApiRoot = `${process.env.REACT_APP_RULES_API_ROOT}/attendees`;

async function countAttendeesAsync(rules, windowStartDate, windowEndDate) {
	const queryString = `rules=${rules}&windowStartDate=${windowStartDate}&windowEndDate=${windowEndDate}`;

	try {
		const result = await axios.get(`${ApiRoot}?${queryString}`);
		return result.data;
	} catch {
		toast.error("Error counting attendees please try again");
		return 0;
	}
}

export default countAttendeesAsync;
